module.exports = __webpack_public_path__ + "static/media/bacteria.0d542311.png";